//MUI
import { styled, Avatar } from '@mui/material';

export const StudentAvatar = styled(Avatar)({
  width: '20vw',
  height: '20vw',
  maxWidth: 500,
  maxHeight: 500,
});
